import classNames from 'classnames';
import { type ChangeEventHandler, type FC, type ReactNode } from 'react';

import s from './Switch.module.scss';

const Switch: FC<{
  disabled?: boolean;
  id?: string;
  label: string | ReactNode;
  name: string;
  isChecked: boolean;
  onChange: (isSet: boolean) => void;
  className?: string;
}> = ({ className, id, label, name, isChecked, onChange, disabled }) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    // Can't preventDefault for css (:has(input:checked) to work
    onChange(Boolean(event.target.checked));
  };

  return (
    <label className={classNames(s.switch, className)} htmlFor={id}>
      <div className={s.switchControl}>
        <div />
      </div>
      {label}
      <input id={id} name={name} type='checkbox' checked={isChecked} onChange={handleChange} disabled={disabled} />
    </label>
  );
};

export default Switch;
